/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type COMMENT_SORT = "CREATED_AT_ASC" | "CREATED_AT_DESC" | "REACTION_DESC" | "REPLIES_DESC" | "%future added value";
export type QueueSortLocal = {
    readonly moderationQueueSort: COMMENT_SORT | null;
    readonly " $refType": "QueueSortLocal";
};
export type QueueSortLocal$data = QueueSortLocal;
export type QueueSortLocal$key = {
    readonly " $data"?: QueueSortLocal$data;
    readonly " $fragmentRefs": FragmentRefs<"QueueSortLocal">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "QueueSortLocal",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "moderationQueueSort",
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Local",
    "abstractKey": null
} as any);
(node as any).hash = 'f6d63e7ec08232bc35d9abdc19817c4b';
export default node;
